import * as React from 'react'
import Loader from '../../../Components/Loader';
import { Modal } from '../../../Components/Modal';
import { AdminIcon } from '../../../Icons/AdminIcon';
import '../Adminbookings.css'
interface IBookingNotesModal{
    handleModal:(key:'delete'|'reschedule'|'send_material'|'submit-new-timeslots'|'remove-timeslots'|'put-notes') => void;
    rowId:number;
    handlePutNotes:(rowId:number,changedNotes:string) => Promise<void>;
    currentNotes:string;
    isSaving:boolean;
        //timeSlots:AdminTimeSlot[];
        //isSavingNewSlots:boolean;handleAvailabletimeSlotSubmit:() => Promise<void>;
}
export const BookingNotesModal = ({handleModal,rowId,handlePutNotes,currentNotes,isSaving}:IBookingNotesModal) => {
    const [internalString,setInternalString] = React.useState<string>(currentNotes);
    console.log(internalString);
    return(
         <Modal  onClose={() => 
         handleModal('put-notes')
         }>
        
           <div style={{cursor:'pointer',width:35}} onClick={()=> handleModal('put-notes')}>
            <AdminIcon.CrossClose fill='hsl(var(--primary))'/>
          </div>
          <div className="sheet-header-container">
        <h2 className="sheet-header-text">Uppdatera Anteckningar</h2>
        <p className="sheet-header-paragraph">
          Anteckingar är inget som delas med klienten. 
        </p>
      </div>
            <div className="sheet-form-container">
                  <div>
          <label htmlFor="content" className="sheet-form-label">
            Antecking.
          </label>
          <textarea
            id="content"
            required
            rows={12}
            value={internalString}
            onChange={(e) => setInternalString(e.target.value)}
            placeholder="Skriv dina anteckningar här..."
            className="sheet-form-input"
          />
        </div>
              
            </div>
            
                        
        <div className="sheet-modal-footer">
               <button
          type="submit"
          className="sheet-form-submit-button"
          onClick={() => handlePutNotes(rowId,internalString)}
        >
          {isSaving ? (<><Loader loaderSize='SMALL' bgColor='white'/>Sparar</>): (<><AdminIcon.Save width={16} height={16} fill='white'/>
          Spara anteckningar</>)}
        </button>
        </div>
        </Modal>
    );
}
